import { useHistory } from 'react-router';
import useCurrentLanguage from './useCurrentLanguage';

export default () => {
  const history = useHistory();
  const currentLang = useCurrentLanguage();

  return url => history.push(`/${currentLang}${url}`);
};
